
import { defineComponent, ref, onMounted,reactive, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useEditor, EditorContent } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import TextAlign from '@tiptap/extension-text-align'
import HardBreak from '@tiptap/extension-hard-break'
import { BoldOutlined, ItalicOutlined, AlignLeftOutlined, AlignCenterOutlined, AlignRightOutlined } from '@ant-design/icons-vue'

export default defineComponent({
    props: {
        id: {
            type: String,
            required: true
        },
    },
    components: {
        EditorContent,
        BoldOutlined, 
        ItalicOutlined, 
        AlignLeftOutlined, 
        AlignCenterOutlined, 
        AlignRightOutlined
    },
    setup (props) {
        const store = useStore()
        const router = useRouter()
        const form : any = reactive({
            id: '',
            parameter:'',
            preview:'',
            template_name:'',
            content: '',
            subject:'',
            preview_content: "",
        })

        const editor = useEditor({
            content: form.content,
            onUpdate: ({ editor }) => {
                var s: any = editor.getJSON().content;
                s = s[0].content;
                var full = "";
                for(const element of s) {
                    if(element['type'] == "text") {
                        full += element['text'];
                    } else if(element['type'] == "hardBreak") {
                        full += "\r\n";
                    }
                }
                form.preview_content = full;
            },
            extensions: [
                StarterKit,
                TextAlign.configure({
                types: ['heading', 'paragraph'],
                }),
                HardBreak.extend({
                addKeyboardShortcuts () {
                    return {
                    Enter: () => this.editor.commands.setHardBreak()
                    }
                }
                }),
            ],
        });
    

        const filterOption = (
            input: string,
            option: { children: { children: string }[] }
            ) => {
            return (
                option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            );
        };

        const handleSaving =(datum: string) => {
            !props.id ? storeRecord(datum) : updateRecord(datum)
        }
        const back = () => {
            router.go(-1) 
        }
        const storeRecord = (datum: string) => {
            form.content = datum
        
            store.dispatch('EmailTemplate/store', form)
            back()
        
        }

        const updateRecord = (datum: string) => {
            form.content = datum
            store.dispatch('EmailTemplate/update', form)
            back()
        }
        
        const breakLine = (str: any) => {
            str = str.toString();
            return str.replaceAll("<br>", '\r\n');
        }

        const stripTags = (str: any) => {
            str = str.toString();
            return str.replace(/(<([^>]+)>)/gi, '');
        }
 
        onMounted(() => {
            if(props.id){
                store.dispatch('EmailTemplate/show',props.id).then((res:any) => {
                    form.id = res.data.id,
                    editor.value?.commands.setContent(res.data.content, false)
                    form.subject = res.data.subject,
                    form.content = res.data.content,
                    form.parameter = res.data.parameter,
                    form.preview = form.parameter + ' '+ res.data.sms_template_1,
                    form.template_name = res.data.template_name,
                    form.preview_content = stripTags(breakLine(res.data.content))
                    console.log(form.content);
                })
            }
            
        })

        watch(form, () => {
            console.log(editor.value)
            var preview = form.parameter?form.parameter:""
            form.preview = preview +' '+ form.preview_content
        });


        return {
            form,
            router,
            editor,
            filterOption,
            handleSaving,
            back,
            stripTags,
            breakLine
        }
    },
})
